const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    newuser: {},
    loading: false,
};
export default function(state = initialState, action) {
    switch (action.type) {
        case 'U_ADD':
            return {
                isAuthenticated: !isEmpty(action.payload),
                newuser: action.payload
            };
        case 'U_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                newuser: action.payload,
            };
        case 'SET_CURRENT_U':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                newuser: action.payload
            };
        case 'U_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}
